import ImageZoom from './image-zoom/ImageZoom.vue';
import Select2 from './select2/Select2.vue';

export default {
  ImageZoom,
  Select2
}
